import request, { getAccessToken, getTenantId } from '@/sheep/request';
import { baseUrl, apiPath } from '@/sheep/config';
import { getTerminal } from '@/sheep/helper/const';
import { MocaOrgTokenIfo } from '@/sheep/utils/moca/session';

const CustomerApi = {
  entryCheck: () =>
    request({
      url: '/operation/thirdparty/moca/app/entry-check',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  getAccountStatus: () =>
    request({
      url: '/operation/thirdparty/moca/app/account/status',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  getCustomerInfo: () =>
    request({
      url: '/operation/thirdparty/moca/app/customer/info',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  getLabelList: () =>
    request({
      url: '/operation/thirdparty/moca/app/label/list',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  signUpdate: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/customer/signUpdate',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  updateCustomerInfo: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/customer/info/update',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  addFeedback: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/feedback/add',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  treatmentContent: (params) =>
    request({
      url: '/operation/thirdparty/moca/app/treatment/progress/content',
      method: 'GET',
      params,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  treatmentProgressList: () =>
    request({
      url: '/operation/thirdparty/moca/app/treatment/progress/list',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  healingConversation: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/healingConversation/conversation',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  getOrganizationList: () =>
    request({
      url: '/operation/thirdparty/moca/app/organization/list',
      method: 'GET',
      custom: { showLoading: false, showError: true, auth: false },
    }),
  getCustomerList: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/customer/list',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  organizationLogin: (data) =>
    request({
      url: '/operation/thirdparty/moca/app/customer/organization/login',
      method: 'POST',
      data,
      custom: { showLoading: false, showError: true, auth: false },
    }),
  uploadFile: (filePath) =>
    new Promise((resolve, reject) => {
      // #ifdef H5
      // H5 端兼容：支持直接传入 FormData / File / Blob（如动态创建的 input 文件或录音 Blob）
      if (
        filePath instanceof FormData ||
        filePath instanceof File ||
        filePath instanceof Blob
      ) {
        const formData = filePath instanceof FormData ? filePath : new FormData();
        if (!(filePath instanceof FormData)) {
          formData.append('file', filePath);
        }
        fetch(baseUrl + apiPath + '/operation/thirdparty/moca/app/file/upload', {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: getAccessToken() ? `Bearer ${getAccessToken()}` : '',
            'tenant-id': getTenantId(),
            terminal: getTerminal(),
            mocaAppOrgToken: uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)
              ? `${uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)}`
              : '',
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data && data.code !== 0) {
              reject(data);
              return;
            }
            resolve(data);
          })
          .catch(reject);
        return;
      }
      // #endif

      uni.uploadFile({
        url: '/operation/thirdparty/moca/app/file/upload',
        filePath,
        name: 'file',
        header: {
          mocaAppOrgToken: uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)
            ? `${uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)}`
            : '',
        },
        success: (res) => resolve(typeof res.data === 'string' ? JSON.parse(res.data) : res.data),
        fail: reject,
      });
    }),
  voiceMatchOption: (file, optionsJson) =>
    new Promise((resolve, reject) => {
      // #ifdef H5
      const formData = file instanceof FormData ? file : new FormData();
      if (!(file instanceof FormData)) {
        formData.append('voiceFile', file, 'voice.wav');
      }
      formData.append('options', optionsJson || '[]');
      fetch(baseUrl + apiPath + '/operation/thirdparty/moca/app/conversation/voiceMatchOption', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: getAccessToken() ? `Bearer ${getAccessToken()}` : '',
          'tenant-id': getTenantId(),
          terminal: getTerminal(),
          mocaAppOrgToken: uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)
            ? `${uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)}`
            : '',
        },
      })
        .then((res) => res.json())
        .then((data) => resolve(data.data))
        .catch(reject);
      return;
      // #endif
      uni.uploadFile({
        url: '/operation/thirdparty/moca/app/conversation/voiceMatchOption',
        filePath: typeof file === 'string' ? file : '',
        name: 'voiceFile',
        formData: { options: optionsJson || '[]' },
        header: {
          mocaAppOrgToken: uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)
            ? `${uni.getStorageSync(MocaOrgTokenIfo.ORG_TOKEN_KEY)}`
            : '',
        },
        success: (res) => {
          const d = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          resolve(d.data);
        },
        fail: reject,
      });
    }),

  getFileUrl: (uri) =>
    request({
      url: '/operation/thirdparty/moca/app/file/getUrl',
      method: 'GET',
      params: { uri },
      custom: { showLoading: false, showError: false, auth: false },
    }),
};

export default CustomerApi;
